export default {
  5000: '管理者にご連絡ください',
  5001: '指定のモデルIDは存在しません',
  5002: 'リクエストがJSON型ではありません',
  5003: '管理者にご連絡ください',
  5004: '対象のデータファイルが存在しません',
  5005: 'カラム「{}」がデータに存在しません',
  5006: '実績データのカラム名は「actual」にしてください',
  5007: '指定のバンドルは存在しません',
  5008: '管理者にご連絡ください',
  5009: '管理者にご連絡ください',
  5010: '指定のトランザクションは存在しません',
  5011: '指定のトランザクションは実行中です'
}



// WEBPACK FOOTER //
// ./src/properties/errorMessage.js